import { memo } from "react";

type Props = {
	title?: string;
	children: React.ReactNode;
};

export const TodoListSectionWrapper = memo(({ title, children }: Props) => {
	return (
		<div className="h-fit rounded border border-zinc-200 p-4">
			{title ? (
				<>
					<h6 className="mb-4 text-lg tracking-wider">{title}</h6>
					<div className="border border-zinc-100" />
					<div className="mt-4 space-y-1">{children}</div>
				</>
			) : (
				<div className="space-y-1">{children}</div>
			)}
		</div>
	);
});

TodoListSectionWrapper.displayName = "TodoListSectionWrapper";
